import { i18n } from '@zet/localization'

import { FormBuilder } from '../../modules/formBuilder'
import { LoadingScreen } from '../../modules/loadingScreen'
import LoanApplicationDetails from '../../modules/loanApplicationDetails'
import LoanReferences from '../../modules/loanRefrences'
import Otp from '../../modules/otp'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'
import { loanType } from '../../types'
import { ApplicationMap } from '../applicationStatusMap'
import { ICON_MAP } from '../iconMap'

export const plStateMap = {
  PL_START: {
    Component: LoadingScreen,
  },
  PL_CUST_FLOW: {
    Component: LoanApplicationDetails,
    props: {
      type: loanType.personalLoan,
      title: i18n.t('loanApplications.stepsToFillLoanApplication.title'),
      steps: [
        i18n.t('loanApplications.stepsToFillLoanApplication.step1'),
        i18n.t('loanApplications.stepsToFillLoanApplication.step4'),
        i18n.t('loanApplications.stepsToFillLoanApplication.step5'),
      ],
      privacyNote: {
        title: i18n.t('loanApplications.loanApplicationPrivacyNote.title'),
        pcNotes: [
          {
            prefix: '\u2022',
            text: i18n.t('loanApplications.loanApplicationPrivacyNote.note1'),
          },
          {
            prefix: '\u2022',
            text: i18n.t('loanApplications.loanApplicationPrivacyNote.note2'),
          },
          {
            prefix: '\u2022',
            text: i18n.t('loanApplications.loanApplicationPrivacyNote.note3'),
            link: i18n.t(
              'loanApplications.loanApplicationPrivacyNote.privacyPolicy'
            ),
          },
        ],
      },
      guideLines: {
        title: i18n.t('loanApplications.thingsForLoanApplication.title'),
        guideLinesList: [
          {
            Icon: ICON_MAP.CreditCardOutlined,
            text: i18n.t(
              'loanApplications.thingsForLoanApplication.guideline1'
            ),
          },
          {
            Icon: ICON_MAP.DocumentCopy,
            text: i18n.t(
              'loanApplications.thingsForLoanApplication.guideline2'
            ),
          },
        ],
      },
    },
  },
  PL_BASIC_DETAILS: {
    Component: FormBuilder,
  },
  PL_PERSONAL_DETAILS: {
    Component: FormBuilder,
  },
  PL_ADDRESS_DETAILS: {
    Component: FormBuilder,
  },
  PL_EMP_DETAILS: {
    Component: FormBuilder,
  },
  PL_DOCUMENT_PROOFS: {
    Component: FormBuilder,
    props: {
      uploadGuidelines: {
        title: 'Document Upload Guidelines:',
        guidelines: [
          'Upload documents in colour only',
          'Ensure clear and readable documents',
          'Keep each file within 2MB size limits for upload',
          'Uploaded files should be in PDF, JPEG or PNG',
          'Upload documents upright to avoid rejection',
        ],
      },
    },
  },
  PL_REFERENCES: {
    Component: LoanReferences,
  },
  PL_CONFIRMATION: {
    Component: StatusScreen,
  },
  PL_REVIEW: {
    Component: Review,
    props: {
      consents: [
        '<div><p>I hereby confirm that all the information I am submitting has been provided by the customer with their full consent. I have not altered or modified any of the details in any way.</div>',
        '<div><p>I hereby confirm that the information submitted is correct to the best of my knowledge. I authorise Vistas Technolabs Pvt Ltd and their partners to contact me for processing of my loan.</div>', // change for customer
      ],
    },
  },
  PL_OTP_SEND: {
    Component: Otp,
  },
  PL_OTP_SUBMIT: {},
  PL_OTP_BLOCKED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No!\nYou have exceeded the maximum \nno. of OTP attempts',
        image: 'ERROR_RETRY',
      },
      showTimeLeft: true,
    },
  },
  PL_OTP_SUBMISSION: {
    Component: LoadingScreen,
  },
  PL_OTP_GENERATED: {
    Component: Otp,
  },
  PL_INCORRECT_DETAILS: {
    Component: StatusScreen,
  },
  PL_HANDLE_ERROR: {
    Component: StatusScreen,
  },
  PL_SUBMIT_SUCCESS: {
    Component: StatusScreen,
  },
  PL_SUBMIT_PROGRESS: {
    Component: StatusScreen,
  },
  PL_SUBMIT_PENDING: {
    Component: StatusScreen,
  },
  PL_SERVER_ERROR: {
    Component: StatusScreen,
  },
  PL_APPLICATION_UNDER_REVIEW: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Details Submitted Successfully \nApplication Under Review!',
        subTitle:
          'Customer details submitted successfully! A ZET Loan expert will contact the customer soon to continue the process',
        image: 'SUBMITTEDFILLED',
        applicationType: 'pl',
        status: ApplicationMap['under_review'],
      },
      secondaryButton: {
        action: 'REDIRECT_LEAD_DETAILS',
        title: i18n.t('loanApplications.loanDetailsSubmitted.viewLeadDetails'),
      },
    },
  },
}
